import { render, staticRenderFns } from "./UnallocUnitCard.vue?vue&type=template&id=0c89680e&"
import script from "./UnallocUnitCard.vue?vue&type=script&lang=js&"
export * from "./UnallocUnitCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports